import React from "react";
import CommonBanner from "../component/Common/CommonBanner";
import HotelPaymentArea from "component/HotelPayment";
import { useTranslation } from "react-i18next";
const HotelPayment = () => {
    const { t } = useTranslation();
    return (
        <>
            <CommonBanner
                heading={t("paymentSubmission")}
                pagination="Booking submission"
            />
            <HotelPaymentArea />
        </>
    );
};

export default HotelPayment;
